module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BR-d02c663d561876c2f6ab9cd30059e620.png";